module.exports = __webpack_public_path__ + "df06c1a1d3910814455d6f05245a5f8d.jpg";